<template>
  <div class="box">
    <h3 class="title is-3">Tidak ada absensi untuk hari ini. Untuk link first timer silahkan gunakan link di bawah ini :</h3>
    <router-link to="/new_people">Link First Timer</router-link>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/NoAbsent.vue